import { Directive, HostListener, Input } from '@angular/core';

@Directive({ selector: '[appPreventPaste]' })
export class PreventPasteDirective {

     @Input() appPreventPaste = false;

     constructor() { }

     @HostListener('paste', ['$event'])
     blockPaste(e: ClipboardEvent): void {
     	if (this.appPreventPaste) {
     		e.preventDefault();
     	}
     }
}
